const SOCCERBET_ORG_UUIDS = ["Gpf_TYqBXd"];
const NO_GRADIENT_ORG_UUIDS = ["08oWZlFAr-"];
const MAXBET_ORG_UUIDS = ["Mwpiy4BL1H", "ITtu0KFbK5", "N2UWnmJitT"];
const SMARTSOFT_ORG_UUIDS = ["wGjViGJcQR"];

export const isSoccerbetOrg = (orgUuid: string | undefined): boolean => {
  if (!orgUuid) return false;
  return SOCCERBET_ORG_UUIDS.includes(orgUuid);
};

export const isNoGradientOrg = (orgUuid: string | undefined): boolean => {
  if (!orgUuid) return false;
  return NO_GRADIENT_ORG_UUIDS.includes(orgUuid);
};

export const isMaxbetOrg = (orgUuid: string | undefined): boolean => {
  if (!orgUuid) return false;
  return MAXBET_ORG_UUIDS.includes(orgUuid);
};

export const isSmartsoftOrg = (orgUuid: string | undefined): boolean => {
  if (!orgUuid) return false;
  return SMARTSOFT_ORG_UUIDS.includes(orgUuid);
};
